export enum CustomRequestDocumentsSponsorTypesEnum {
  BEFORE_TRAVEL = 'beforeTravel',
  AFTER_ARRIVAL = 'afterArrival'
}
